var util = {};

util.getFirstDayOfMonth = function (date) {
    date.setDate(1);
    return date;
}

util.addDay = function(date, qty) {
    var newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    newDate.setDate(date.getDate() + qty);
    return newDate;
}

util.currentDate = function () {
    var myDate = new Date();
    return util.formatDate(myDate,"yyyy-MM-dd");
}


util.latestWeek = function () {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    return util.formatDate(start,"yyyy-MM-dd")+" - "+util.formatDate(end,"yyyy-MM-dd");
}


util.formatDateRange = function (dateRange) {
    if (dateRange != null && dateRange[0] != null && dateRange[1] != null) {
        return this.formatDate(new Date(dateRange[0]), "yyyy-MM-dd") + " - " + this.formatDate(new Date(dateRange[1]), "yyyy-MM-dd");
    } else {
        return "";
    }
}

util.formatLocalDate = function (date) {
    if (date != null && date != "") {
        return this.formatDate(new Date(date), "yyyy-MM-dd");
    } else {
        return "";
    }
}

util.formatLocalDateTime = function (date) {
    if (date != null && date != "") {
        return this.formatDate(new Date(date), "yyyy-MM-dd hh:mm:ss");
    } else {
        return "";
    }
}

util.formatLocalMonth = function (date) {
    if (date != null && date != "") {
        return this.formatDate(new Date(date), "yyyy-MM");
    } else {
        return "";
    }
}

util.formatDate = function (date, format) {
    var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        "S": date.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
}

util.pickerDateOption =function (obj) {
    let shortcuts={
        shortcuts: [{
            text: obj.$t('util.today'),
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: obj.$t('util.yesterday'),
            onClick(picker) {
                const start = new Date();
                const end = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24);
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: obj.$t('util.currentWeek'),
            onClick(picker) {
                const now = new Date();
                const end = new Date();
                const start=new Date(now.getFullYear(), now.getMonth(), now.getDate()+1-   now.getDay());
                end.getDay();
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: obj.$t('util.currentMonth'),
            onClick(picker) {
                const now=new Date();
                const day  = new Date(now.getFullYear(),now.getMonth()+1,0);
                const start = new Date();
                const end = new Date();
                start.setDate(1);
                end.setDate(day.getDate());
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: obj.$t('util.latestWeek'),
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                end.setTime(end.getTime());
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: obj.$t('util.latestMonth'),
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
                end.setTime(end.getTime());
                picker.$emit('pick', [start, end]);
            }
        }]
    }
    return shortcuts;
}


util.getAge=function(strBirthday){
    let returnAge,strBirthdayArr=strBirthday.split("-");
    let birthYear = strBirthdayArr[0],birthMonth = strBirthdayArr[1],birthDay = strBirthdayArr[2];
    let day = new Date();
    let nowYear = day.getFullYear(),nowMonth = day.getMonth() + 1,nowDay = day.getDate();

    if(nowYear == birthYear){
        returnAge = 0;
    } else{
        let ageDiff = nowYear - birthYear ;
        if(ageDiff > 0){
            if(nowMonth == birthMonth) {
                let dayDiff = nowDay - birthDay;
                if(dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff ;
                }
            } else {
                let monthDiff = nowMonth - birthMonth;
                if(monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else{
                    returnAge = ageDiff ;
                }
            }
        } else {
            returnAge = -1;
        }
    }
    return returnAge;
}

export default util;


// WEBPACK FOOTER //
// ./src/util/time.js